import { tileFile, tileName } from "../game/tiles";
import { BACK, tileArt } from "./tileArt";

// A tile shown in the page itself: the results, the call buttons, the waits, the dora indicators. The
// table's own tiles are the tile layer's (ui/TileLayer).

export interface TileProps {
  id?: number; // absent: a face-down tile
  red?: boolean; // the rules have red fives
  size?: "s" | "m" | "l";
  sideways?: boolean; // a riichi declaration or a called tile
  dim?: boolean;
  tsumogiri?: boolean; // a discard straight from the draw, shown a little darker, as most clients do
  highlight?: boolean;
}

export function Tile(props: TileProps) {
  // The face, cut from the face sheet (ui/tileArt): the white dragon's frame and the red fives' mark are in it.
  const cls = () =>
    ["tile", `tile-${props.size ?? "m"}`, props.sideways && "sideways", props.dim && "dim", props.tsumogiri && "tsumogiri", props.highlight && "highlight", props.id === undefined && "back"]
      .filter(Boolean)
      .join(" ");
  const name = () => (props.id === undefined ? undefined : tileName(props.id, props.red ?? false));
  return (
    <span
      class={cls()}
      aria-label={name() ?? "hidden tile"}
      title={name()}
      style={tileArt(props.id === undefined ? BACK : tileFile(props.id, props.red ?? false))}
    />
  );
}
